export class ArticleStatusReceivedModel {
  ArticleStatusReportAPI: string = "";
  GetJournalList: string = "";
  VolumeIssueListAPI: string = "";
}
